import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyle from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        width: '100%',
        maxHeight: 'calc(100% - 88px)',
        paddingRight: theme.spacing(2),
      },
      atualizar: {
        backgroundColor: 'white',
      },
      filtros: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
      },
      filtroLeft: {
        width: 'calc(55% - 8px)',
        marginRight: theme.spacing(1),
      },
      filtroRight: {
        width: 'calc(45% - 8px)',
        marginLeft: theme.spacing(1),
      },
      list: {
        flex: 1,
        overflow: 'hidden',
        boxSizing: 'border-box',
        padding: theme.spacing(2, 0),
      },
      listContent: {
        width: '100%',
        maxHeight: 'calc(100% - 40px)',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        overflowY: 'auto',
        display: 'grid',
        columnGap: '12px',
        rowGap: '16px',
        gridTemplateColumns: 'repeat(3, 1fr)',
        paddingBottom: theme.spacing(2),
        paddingRight: theme.spacing(1),
        scrollbarColor: `${sicrediStyle.primarySicredi} ${sicrediStyle.secondarySicrediLight}`,
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar-track': {
          backgroundColor: sicrediStyle.sicrediLightest,
        },

        '&::-webkit-scrollbar': {
          width: '12px',
          height: '12px',
        },

        '&::-webkit-scrollbar-thumb': {
          transition: 'all 0.3s ease',
          borderRadius: '10px',
          backgroundColor: sicrediStyle.sicrediLight,
          borderWidth: '3px',
          borderStyle: 'solid',
          borderColor: sicrediStyle.sicrediLightest,

          '&:hover': {
            borderWidth: '2px',
            backgroundColor: 'darken($primary-sicredi-light, 5%)',
          },
        },

        '&::-webkit-scrollbar-button': {
          display: 'none',
        },
      },
      conversa: {
        transition: '.3s',
        borderLeftWidth: 4,
        borderLeftStyle: 'solid',
        borderLeftColor: sicrediStyle.secondarySicrediLight,
        color: sicrediStyle.secondarySicrediDarker,
        overflow: 'hidden',
        flexShrink: 0,
      },
      respondido: {
        borderLeftColor: sicrediStyle.primarySicredi,
      },
      pendente: {
        borderLeftColor: sicrediStyle.warningSicredi,
      },
      paginacao: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: 40,
      },
      paginacaoPrev: {
        width: 16,
        height: 16,
        transform: 'rotate(90deg)',
      },
      paginacaoNext: {
        width: 16,
        height: 16,
        transform: 'rotate(-90deg)',
      },
      paginacaoNumber: {
        minWidth: 'unset',
      },
      ativo: {
        transition: '.3s',
        borderLeftColor: 'transparent',
        backgroundColor: sicrediStyle.primarySicrediDark,
        color: 'white',
      },
      item: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: 8,
        boxSizing: 'border-box',
      },
      coopInfo: {
        flex: 'auto',
        fontSize: 14,
        fontWeight: 500,
        textAlign: 'left',
        lineHeight: '20px',
        color: sicrediStyle.primarySicredi,
        '$ativo &': {
          color: 'white',
        },
      },
      fullTime: {
        fontSize: 12,
        fontWeight: 700,
        textAlign: 'right',
        lineHeight: '12px',
      },
      associado: {
        fontSize: 18,
        fontWeight: 500,
        textAlign: 'left',
        width: '100%',
        lineHeight: '28px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
      cpf: {
        flex: 1,
        fontSize: 10,
        fontWeight: 400,
        lineHeight: '20px',
        textAlign: 'left',
      },
      filtro: {
        display: 'flex',
        flexWrap: 'wrap',
      },
      statusFiltro: {
        marginTop: theme.spacing(2),
      },
      statusFiltroTotals: {
        display: 'flex',
        justifyContent: 'stretch',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: '100%',
      },
      select: {
        flexShrink: 0,
      },
      inputIcon: {
        fontSize: 24,
        color: sicrediStyle.primarySicredi,
        pointerEvents: 'none',
        marginLeft: -24,
      },
      filtroChips: {
        display: 'flex',
        justifyContent: 'space-between',
      },
      chips: {
        flexShrink: 1,
        fontSize: 12,
        fontWeight: 'normal',
        margin: '8px auto',
        height: 28,
        '& .MuiChip-iconSmall': {
          width: 16,
          height: 16,
          marginLeft: 12,
        },
      },
      chipRespondidos: {
        backgroundColor: sicrediStyle.primarySicrediLight,
        color: sicrediStyle.primarySicrediDark,
        marginLeft: 0,
      },
      chipPendentes: {
        backgroundColor: sicrediStyle.warningSicrediLight,
        color: sicrediStyle.warningSicrediDark,
        marginRight: 0,
      },
    }),
  { name: 'ConversasAssessor' }
);
